class PDPImageSlider extends HTMLElement {
  constructor() {
    super();

    this.swiperInstance = null;
    this.swiperContainerId = this.id;
    this.dataId = null;
  }

  connectedCallback() {
    this.dataId = this.getAttribute('data-id');
    this.initSwiper();
  }

  disconnectedCallback() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(false, false);
    }
  }

  initSwiper() {
    if (window.Swiper) {
      const paginationEnabled = {
        pagination: {
          el: `#swiper-pagination-${this.dataId}`,
          type: 'bullets',
        },
      };

      this.swiperInstance = new Swiper(`#${this.swiperContainerId}`, {
        ...paginationEnabled,
        speed: DEFAULT_SLIDER_SPEED,
        loop: true,
        slidesPerView: 1,
        watchOverflow: true,
        effect: 'slider',
        observer: true,
        preventInteractionOnTransition: true,
      });
    } else {
      console.warn('Swiper.js is not loaded.');
    }
  }
}

customElements.define('pdp-image-slider', PDPImageSlider);
